(function () {
  'use strict';
  if (window.CapirusGuarantees || (window.Shopify && window.Shopify.designMode)) return;

  var id = 'product_landings_r2_v1';
  var key = 'capirus_product_landings_r2_v1';
  var stickyKey = key + '_visitor';
  var qaKey = key + '_qa';
  var ttl = 30 * 60 * 1000;
  var lifetime = 90 * 24 * 60 * 60 * 1000;
  var product = '/products/capirus-growth-oil-ultimate-hair-growth-solution-for-men';
  var views = { control: 'garantia-escepticas', botanica_v1: 'mujeres-anticaida-botanica' };
  var url = new URL(window.location.href);
  var router = document.querySelector('[data-capirus-guarantee-router]');
  var now = Date.now();
  var assignment = null;
  var published = false;
  var cartSaved = false;
  var retries = 0;

  function storage(name) {
    try { return window[name]; } catch (error) { return { getItem: function () { return null; }, setItem: function () {}, removeItem: function () {} }; }
  }
  var sessionStore = storage('sessionStorage');
  var localStore = storage('localStorage');

  function read(store, name) {
    try { return JSON.parse(store.getItem(name) || 'null'); } catch (error) { return null; }
  }

  function write(store, name, value) {
    try {
      var text = JSON.stringify(value);
      store.setItem(name, text);
      return store.getItem(name) === text;
    } catch (error) { return false; }
  }

  function remove(store, name) {
    try { store.removeItem(name); } catch (error) {}
  }

  function valid(value) {
    return value && value.experimentId === id && Object.hasOwn(views, value.variantId)
      && typeof value.visitorId === 'string' && /^[a-f0-9-]{16,64}$/.test(value.visitorId)
      && Number.isFinite(value.createdAt) && now - value.createdAt < lifetime
      && value.createdAt <= now && Number.isFinite(value.lastSeen)
      && now - value.lastSeen < ttl && value.lastSeen <= now
      && Number.isFinite(value.sessionId) && Number.isFinite(value.firstSessionId);
  }

  function cookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=1800; SameSite=Lax; Secure';
  }

  function cookieRead(name) {
    try {
      var item = document.cookie.split('; ').find(function (part) { return part.startsWith(name + '='); });
      return item ? JSON.parse(decodeURIComponent(item.slice(name.length + 1))) : null;
    } catch (error) { return null; }
  }

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function'
      && privacy.analyticsProcessingAllowed());
  }

  function randomId() {
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
  }

  function nextVariant() {
    var number = new Uint32Array(1);
    window.crypto.getRandomValues(number);
    return number[0] < 2147483648 ? 'control' : 'botanica_v1';
  }

  function eligible() {
    return /^(facebook|instagram|meta|fb|ig)$/i.test(url.searchParams.get('utm_source') || '')
      && /^(paid|paid_social|cpc|ppc)$/i.test(url.searchParams.get('utm_medium') || '')
      && !!url.searchParams.get('utm_campaign');
  }

  function isPreview() {
    return url.searchParams.has('preview_theme_id') || url.searchParams.has('_fd')
      || /shopifypreview\.com$/.test(url.hostname);
  }

  function target(variant) {
    var destination = new URL(product, url.origin);
    url.searchParams.forEach(function (value, name) {
      if (name !== 'view') destination.searchParams.append(name, value);
    });
    destination.searchParams.set('view', views[variant]);
    destination.hash = url.hash;
    return destination;
  }

  var forced = url.searchParams.get('cap_exp') === id
    && Object.hasOwn(views, url.searchParams.get('cap_variant'));
  var qa = forced || isPreview() || url.searchParams.has('cap_exp') || url.searchParams.has('cap_variant');

  if (router) {
    var live = router.dataset.enabled === 'true' && eligible() && !qa;
    var variant = 'control';
    if (live || forced) {
      var previous = qa ? null : read(sessionStore, key);
      var sticky = qa ? null : read(localStore, stickyKey);
      var reusable = sticky && sticky.experimentId === id && Object.hasOwn(views, sticky.variantId)
        && /^[a-f0-9-]{16,64}$/.test(sticky.visitorId || '')
        && Number.isFinite(sticky.createdAt) && now - sticky.createdAt < lifetime && sticky.createdAt <= now;
      variant = forced ? url.searchParams.get('cap_variant')
        : valid(previous) && !previous.qa ? previous.variantId : reusable ? sticky.variantId : nextVariant();
      var sessionId = valid(previous) && !qa ? previous.sessionId : Math.floor(now / 1000);
      assignment = {
        experimentId: id,
        variantId: variant,
        visitorId: valid(previous) && !qa ? previous.visitorId : reusable ? sticky.visitorId : randomId(),
        createdAt: valid(previous) && !qa ? previous.createdAt : reusable ? sticky.createdAt : now,
        firstSessionId: valid(previous) && !qa ? previous.firstSessionId
          : reusable ? sticky.firstSessionId : sessionId,
        sessionId: sessionId,
        lastSeen: now,
        assignedAt: now,
        entryPath: url.pathname,
        source: (url.searchParams.get('utm_source') || '').slice(0, 40),
        medium: (url.searchParams.get('utm_medium') || '').slice(0, 40),
        campaign: (url.searchParams.get('utm_campaign') || '').slice(0, 100),
        adId: (url.searchParams.get('ad_id') || url.searchParams.get('utm_content') || '').slice(0, 100),
        qa: qa,
        arrived: false
      };
      if (!write(sessionStore, qa ? qaKey : key, assignment)) {
        assignment = null;
        variant = 'control';
      }
    }
    if (!qa) remove(sessionStore, qaKey);
    cookie(key + '_qa_mode', qa ? '1' : '0');
    document.documentElement.dataset.experimentRouting = assignment ? (qa ? 'qa' : 'assigned') : 'excluded';
    var destination = target(variant);
    var fallback = document.querySelector('[data-capirus-guarantee-fallback]');
    if (fallback) fallback.href = destination.href;
    window.location.replace(destination.href);
    return;
  }

  var qaRecord = read(sessionStore, qaKey);
  assignment = valid(qaRecord) ? qaRecord : read(sessionStore, key);
  if (!valid(assignment)) assignment = allowed() ? cookieRead(key) : null;
  if (!valid(assignment)) return;
  if (qa || assignment.qa || valid(qaRecord)) {
    if (assignment.qa && url.searchParams.get('view') === views[assignment.variantId]) {
      assignment.arrived = true;
      assignment.lastSeen = now;
      write(sessionStore, qaKey, assignment);
    }
    document.documentElement.dataset.guaranteeExperiment = 'qa';
    window.CapirusGuarantees = { assignment: null, qa: true, params: function () { return {}; } };
    function publishQa() {
      if (published || !assignment.qa || !assignment.arrived || !allowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return published;
      var result = window.Shopify.analytics.publish('capirus_guarantee_ready', Object.assign({}, assignment));
      published = result !== false;
      if (result && typeof result.then === 'function') result.then(function (ok) { published = !!ok; }).catch(function () { published = false; });
      return published;
    }
    document.addEventListener('visitorConsentCollected', publishQa);
    publishQa();
    var qaRetry = window.setInterval(function () {
      retries += 1;
      if (publishQa() || retries >= 60) window.clearInterval(qaRetry);
    }, 1000);
    return;
  }

  var landing = url.pathname.replace(/^\/(es|en)(?=\/)/, '') === product;
  var matches = landing && url.searchParams.get('view') === views[assignment.variantId];
  if (landing && !matches) return;
  if (!assignment.arrived && !matches) return;
  if (matches && !assignment.arrived) {
    assignment.arrived = true;
    assignment.redirectMs = Math.max(0, now - assignment.assignedAt);
  }
  assignment.lastSeen = now;
  write(sessionStore, key, assignment);
  document.documentElement.dataset.guaranteeExperiment = assignment.variantId;

  function params() {
    return {
      experiment_id: id,
      variant_id: assignment.variantId,
      experiment_surface: 'product_landings',
      experiment_first_session: assignment.sessionId === assignment.firstSessionId ? 'yes' : 'no'
    };
  }

  window.CapirusGuarantees = { assignment: assignment, qa: false, params: params };

  function attribution() {
    return { _capirus_guarantees: JSON.stringify(assignment) };
  }

  function persist() {
    if (!allowed()) return false;
    write(localStore, stickyKey, assignment);
    cookie(key, JSON.stringify(assignment));
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var input = form.querySelector('[name="properties[_capirus_guarantees]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_capirus_guarantees]';
        form.appendChild(input);
      }
      input.value = JSON.stringify(assignment);
    });
    return true;
  }

  function saveCart() {
    if (cartSaved || !persist()) return;
    cartSaved = true;
    fetch((window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attribution() }),
      keepalive: true
    }).then(function (response) { if (!response.ok) cartSaved = false; })
      .catch(function () { cartSaved = false; });
  }

  function ready() {
    if (!persist()) return false;
    if (!published && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      var result = window.Shopify.analytics.publish('capirus_guarantee_ready', Object.assign({}, assignment));
      published = result !== false;
      if (result && typeof result.then === 'function') result.then(function (ok) { published = !!ok; }).catch(function () { published = false; });
    }
    return published;
  }

  document.addEventListener('visitorConsentCollected', function () { ready(); saveCart(); });
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"]')) { persist(); saveCart(); }
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('a[href*="/checkout"],button[name="checkout"],#checkout')) saveCart();
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { cartSaved = false; saveCart(); });
  }
  ready();
  saveCart();
  var retry = window.setInterval(function () {
    retries += 1;
    if (ready() || retries >= 60) window.clearInterval(retry);
  }, 1000);
})();
